<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconRecording_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3 3C1.343 3 0 4.433 0 6.2v11.6C0 19.567 1.343 21 3 21h18c1.657 0 3-1.433 3-3.2V6.2C24 4.433 22.657 3 21 3zm16.879 7.891h1.496a3.3 3.3 0 0 0-.328-1.141 2.7 2.7 0 0 0-.656-.842 2.8 2.8 0 0 0-.925-.527 3.4 3.4 0 0 0-1.128-.181q-.922 0-1.66.448-.738.444-1.168 1.293T15.08 12q0 1.207.423 2.055.427.85 1.162 1.297.738.448 1.673.448.673 0 1.206-.213a2.89 2.89 0 0 0 1.54-1.427q.232-.473.291-.982l-1.496-.008a1.6 1.6 0 0 1-.185.528 1.4 1.4 0 0 1-.328.393 1.4 1.4 0 0 1-.454.243 1.8 1.8 0 0 1-.55.082q-.53 0-.932-.274-.404-.275-.629-.813-.222-.538-.222-1.329 0-.77.222-1.308.222-.54.625-.823.403-.285.946-.286.3 0 .557.09.26.092.458.26.198.17.325.413.126.238.167.545M9.313 8.301V15.7h4.727v-1.29h-3.248v-1.766h2.992v-1.29h-2.992V9.591h3.235V8.3zM3 15.7V8.3h2.76q.793 0 1.353.3.563.296.857.842.297.54.297 1.275 0 .736-.3 1.268a2 2 0 0 1-.935.839l1.485 2.874H6.884l-1.325-2.623h-1.08V15.7zm1.48-3.88h1.003q.424 0 .704-.122a.85.85 0 0 0 .417-.369q.14-.246.14-.61 0-.369-.14-.622a.88.88 0 0 0-.42-.383q-.28-.133-.707-.133h-.998z"
        clip-rule="evenodd"
    />
</svg>
